export default function DownArrow(props) {
  return (
    <svg width='12.018' height='6.009' viewBox='0 0 12.018 6.009' fill='#0e77ef' {...props}>
      <path d='M0,0H12.018L6.009,6.009Z' />
    </svg>
  )
}
